import React, { useContext } from 'react'; // Agregué useContext aquí
import { Navigate, Outlet } from 'react-router-dom';
import { AuthContext } from '../context/AuthContext'; // <--- RUTA CORREGIDA

const RoleGuard = ({ allowedRoles }) => {
  const { user, loading } = useContext(AuthContext);

  if (loading) return <div>Cargando permisos...</div>;

  if (!user) {
    return <Navigate to="/admin/login" replace />;
  }

  // Si el rol no coincide (y existe el array de roles permitidos)
  if (allowedRoles && !allowedRoles.includes(user.rol)) {
    return <Navigate to="/admin/dashboard" replace />;
  }

  return <Outlet />;
};

export default RoleGuard;